import createUrl from '@glass/common/modules/url/createUrl';
import sanitizePathSlashes from '@glass/common/modules/url/sanitizePathSlashes';
import removeEmptyKeys from '@glass/common/modules/utils/removeEmptyKeys';

export const compileRegex = /\[(\w+)]/g;

type CompileDynamicUrl = {
  origin?: string;
  pathname?: string;
  query: Record<string, string>;
  isIncludeQueryParams?: boolean;
};

// this will take a (to) path in the nextjs dynamic pattern using /[this]/[that] and will compile params like { this: 'aaa', that: 'bbb' } into the proper nextjs link props (as and href)
// https://nextjs.org/docs/api-reference/next/link
const compileDynamicUrl = ({
  origin,
  pathname,
  query,
  isIncludeQueryParams = true,
}: CompileDynamicUrl) => {
  if (!pathname) {
    return null;
  }
  const asQuery = {
    ...removeEmptyKeys<Record<string, string>>(query),
  };

  const asPath = sanitizePathSlashes(
    pathname.replace(compileRegex, (...args) => {
      if (asQuery[args[1]]) {
        delete asQuery[args[1]];
        return query[args[1]];
      }
      throw new Error('missing query parameter');
    }),
  );

  return createUrl({ origin, pathname: asPath, query: isIncludeQueryParams ? asQuery : null });
};

export default compileDynamicUrl;
